










import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zalohy/store/edit';
import { NAME } from '@/modules/servis/zalohy/constants';
import zalohaComponentBuilder from '@/modules/components/zalohy/Edit.vue';
import { zalohyFactory } from '@/modules/components/zalohy/edit';
import { DokladNaplnFakturaci, NAME as FAKTURACE } from '@/modules/uctenky/fakturace/constants';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import _ from 'lodash';

export default zalohyFactory(NAME, store).extend({
	name: NAME,
	components: {
		Zalohy: zalohaComponentBuilder,
	},
	data() {
		return {
			vuexStore: store,
			DokladNaplnFakturaci,
		};
	},
	computed: {
		...genVuexComputeds(store),
		isZalohovaFakturaDisabled() {
			return !(_.isNull(this.UzavreniDat) && _.isNull(this.PrvniDdDat));
		},
		isPrvniDdDisabled() {
			return !(!_.isNull(this.UzavreniDat) && _.isNull(this.PrvniDdDat));
		},
	},
	methods: {
		async zalohovaFaktura(dokladNaplnFakturaci: DokladNaplnFakturaci) {
			if (this.isCreateMode) await this.changeToEdit();
			if (this.isModified) await this.save(false);

			openEdit(FAKTURACE, PageMode.CREATE, {
				filter: {
					zakazkaId: this.ZakazkaId,
					zakazkaZalohaId: this.ZakzalohaId,
					dokladNaplnFakturaci,
				},
			});
		},
	},
});
